import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { ComponentsModule } from '../../components/components.module'
import { OurSubscriptionsComponent } from '../../pages/home/components/our-subscriptions/our-subscriptions.component'
import { ContactHeaderComponent } from './components/contact/contact-header/contact-header.component'
import { FiltersComponent } from './components/help/filters/filters.component'
import { QuestionsSectionComponent } from './components/help/questions-section/questions-section.component'
import { InformationRoutingModule } from './information-routing.module'
import { AdvertisementPageComponent } from './pages/advertisement-page/advertisement-page.component'
import { ContactComponent } from './pages/contact/contact.component'
import { HelpPageComponent } from './pages/help-page/help-page.component'
import { NewWebsiteComponent } from './pages/new-website/new-website.component'

@NgModule({
  imports: [
    CommonModule,
    InformationRoutingModule,
    ComponentsModule,
    ReactiveFormsModule,
    OurSubscriptionsComponent,
    AdvertisementPageComponent,
    ContactComponent,
    ContactHeaderComponent,
    HelpPageComponent,
    FiltersComponent,
    QuestionsSectionComponent,
    NewWebsiteComponent,
  ],
})
export class InformationModule {}
